/** Match Firebase prerender paths (directory/index.html) and hosting redirects. */
export function withTrailingSlash(path: string): string {
  if (!path || path === '/') {
    return path;
  }

  return path.endsWith('/') ? path : `${path}/`;
}

export function buildAbsoluteCanonicalUrl(siteOrigin: string, path: string): string {
  const origin = siteOrigin.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${withTrailingSlash(normalizedPath)}`;
}
